<template>
  <div id="endDevices">
    <!-- the user has no cluster => display the warning page -->
    <!-- check true and false to not display anything while it's null -->
    <no-groups v-if="$store.getters.userHasClusters===false" groups="clusters" />

    <template v-if="$store.getters.userHasClusters===true">
      <select-group all group="cluster" />

      <card :title="$t('endDevices:filter')" :title-small="titleSmallNbFilters" :visible="false" collapsible>
        <div slot="card-body">
          <div class="form-row">
            <div class="form-group col-md-5">
              <label for="devEui" class="control-label">{{ $t('endDevices:devEui') | capitalize }}</label>
              <multiselect id="devEui"
                           v-model="filterDevEui"
                           :options="devEuiList"
                           :multiple="true"
                           :internal-search="false"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :show-labels="false"
                           :options-limit="maxPageSizePerFilterRequest + 1"
                           :placeholder="$t('endDevices:typeAndSelectEndDevices') | capitalize"
                           track-by="devEui"
                           label="devEui"
                           @search-change="getDevEuiList"
              >
                <span slot="noResult">{{ $t('endDevices:noData') | capitalize }}</span>
              </multiselect>
            </div>

            <div class="form-group col-md-3">
              <label for="filterName" class="control-label">{{ $t('endDevices:name') | capitalize }}</label>
              <input id="filterName"
                     v-model="filterName"
                     v-validate="'text'"
                     :data-vv-as="$t('endDevices:name')"
                     :class="{ 'is-invalid': errors.has('filterName') }"
                     type="text"
                     name="filterName"
                     class="form-control"
              >
              <div class="invalid-feedback">{{ errors.first('filterName') }}</div>
            </div>

            <div class="form-group col-md-2">
              <label for="devAddr" class="control-label">{{ $t('endDevices:devAddr') | capitalize }}</label>
              <input id="devAddr"
                     v-model="filterDevAddr"
                     v-validate="'hexa8'"
                     :data-vv-as="$t('endDevices:devAddr')"
                     :class="{ 'is-invalid': errors.has('devAddr') }"
                     type="text"
                     name="devAddr"
                     class="form-control"
              >
              <div class="invalid-feedback">{{ errors.first('devAddr') }}</div>
            </div>

            <div class="form-group col-md-2">
              <label for="classType" class="control-label d-block">{{ $t('endDevices:classType') | capitalize }}</label>
              <input id="classTypeA"
                     v-model="filterClass"
                     type="checkbox"
                     value="A"
                     name="classType"
              >
              <label for="classTypeA" class="control-label mr-3">A</label>

              <input id="classTypeB"
                     v-model="filterClass"
                     type="checkbox"
                     value="B"
                     name="classType"
              >
              <label for="classTypeB" class="control-label mr-3">B</label>

              <input id="classTypeC"
                     v-model="filterClass"
                     type="checkbox"
                     value="C"
                     name="classType"
              >
              <label for="classTypeC" class="control-label">C</label>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="region" class="control-label">{{ $t('endDevices:region') | capitalize }}</label>
              <multiselect id="region"
                           v-model="filterRegions"
                           :options="regions"
                           :multiple="true"
                           :searchable="false"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :show-labels="false"
                           :placeholder="$t('endDevices:selectRegion') | capitalize"
              />
            </div>

            <div class="form-group col-md-4">
              <label for="macVersion" class="control-label">{{ $t('endDevices:macVersion') | capitalize }}</label>
              <multiselect id="macVersion"
                           v-model="filterMacVersions"
                           :options="macVersions"
                           :multiple="true"
                           :searchable="false"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :show-labels="false"
                           :placeholder="$t('endDevices:selectMacVersion') | capitalize"
              />
            </div>

            <div class="form-group col-md-4">
              <label for="regionalParameterRevision" class="control-label">{{ $t('endDevices:regionalParameterRevision') | capitalize }}</label>
              <multiselect id="regionalParameterRevision"
                           v-model="filterRegionalParameterRevisions"
                           :options="regionalParameterRevisions"
                           :multiple="true"
                           :searchable="false"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :show-labels="false"
                           :placeholder="$t('endDevices:selectRegionalParameterRevision') | capitalize"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="status" class="control-label">{{ $t('endDevices:status') | capitalize }}</label>
              <multiselect id="status"
                           v-model="filterStatus"
                           :options="filterStatuses"
                           :multiple="true"
                           :searchable="false"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :show-labels="false"
                           :placeholder="$t('endDevices:selectStatus') | capitalize"
                           track-by="id"
                           label="name"
              />
            </div>

            <div class="form-group col-md-4">
              <label for="profile" class="control-label">{{ $t('endDevices:profile') | capitalize }}</label>
              <select id="profile" v-model="filterProfile" class="form-control">
                <option value="" />
                <option value="STATIC">{{ $t('endDevices:profiles.STATIC') | capitalize }}</option>
                <option value="WALKING">{{ $t('endDevices:profiles.WALKING') | capitalize }}</option>
                <option value="VEHICLE">{{ $t('endDevices:profiles.VEHICLE') | capitalize }}</option>
              </select>
            </div>

            <div class="form-group col-md-4">
              <label for="filterAdr" class="control-label">{{ $t('endDevices:adr') | capitalize }}</label>
              <select id="filterAdr" v-model="filterAdr" class="form-control">
                <option value="" />
                <option value="true">{{ $t('endDevices:adrEnabled') | capitalize }}</option>
                <option value="false">{{ $t('endDevices:adrDisabled') | capitalize }}</option>
              </select>
            </div>
          </div>
        </div>

        <div slot="card-footer">
          <button id="filterButton" class="btn btn-primary" @click="filter()">{{ $t('endDevices:search') | capitalize }}</button>
        </div>
      </card>

      <grid id="endDevicesGrid"
            :title="$t('endDevices:endDevices')"
            :columns.sync="columns"
            :paginated-dto="endDevices"
            :manual-export="exportAllEndDevices"
            :custom-export-label="$t('endDevices:exportAll')"
            @load="filter"
      >
        <template #header-right>
          <progress-circular v-show="exportAllProgress" :progress="exportAllProgress" />
          <!-- Need a link to click on when we get the csv url, can't use download attribute because of IE11 -->
          <a id="exportAllUrl" :href="exportAllUrl" class="hidden" />
        </template>

        <template slot="addAllToSelection">
          <i :title="$t('endDevices:addAllToSelection') | capitalize" class="icon-cart-all" @click="addAllToSelection" />
        </template>

        <template slot="selection" slot-scope="props">
          <i v-if="!$store.getters.isEndDeviceInSelection(props.dto)" :title="$t('endDevices:addToSelection') | capitalize" class="icon-cart-add" @click="addToSelection(props.dto)" />
          <i v-else :title="$t('endDevices:removeFromSelection') | capitalize" class="icon-cart-remove" @click="removeFromSelection(props.dto)" />
        </template>

        <router-link slot="devEui" slot-scope="props" :to="{name: 'endDevice', params: {devEui: props.dto.devEui}}">{{ props.dto.devEui }}</router-link>

        <span slot="name" slot-scope="props" :title="props.dto.name" class="max-width-cell">{{ props.dto.name }}</span>

        <template slot="cluster" slot-scope="props">{{ props.dto.cluster ? props.dto.cluster.name : '👻' }}</template>
        <template slot="status" slot-scope="props">{{ $t('endDevices:statuses.' + props.dto.status) | capitalize }}</template>
        <template slot="profile" slot-scope="props">{{ $t('endDevices:profiles.' + props.dto.profile) | capitalize }}</template>
        <template slot="adrEnabled" slot-scope="props">{{ $t('endDevices:adrState.' + props.dto.adrEnabled) | capitalize }}</template>
        <template slot="lastDataUpDate" slot-scope="props">{{ props.dto.lastDataUpDate | date }}</template>
        <template slot="lastDataDownDate" slot-scope="props">{{ props.dto.lastDataDownDate | date }}</template>
      </grid>

      <a v-show="$store.getters.endDevicesSelection.length>0" id="goToSelectionLink" href="/#/selection/end-devices" class="btn btn-primary mt-3">{{ $t('endDevices:doActionOnSelection') | capitalize }}</a>
    </template>
  </div>
</template>

<script>
import { isEqual, sortBy, map, upperFirst, debounce, isEmpty, cloneDeep, remove, each } from 'lodash-es'
import { mapGetters } from 'vuex'
import regions from '@/configuration/regions'
import to from '@/modules/await-to-js'
import constants from '@/configuration/constants'
import endDevicesStatuses from '@/configuration/endDevicesStatuses'
import exportAllEndDevices from '@/mixins/exportAllEndDevices'

import NoGroups from '@/components/page/errors/NoGroups'

export default {
  titleKey: 'endDevices',

  components: { NoGroups },

  mixins: [exportAllEndDevices],

  data () {
    return {
      // List of endDevices for devEui filters
      devEuiList: [],
      // Filters
      filterName: '',
      filterClass: [],
      filterRegions: [],
      filterMacVersions: [],
      filterRegionalParameterRevisions: [],
      filterStatus: [],
      filterProfile: '',
      filterDevEui: [],
      filterAdr: '',
      filterDevAddr: '',
      nbFilters: 0,

      columns: [
        { headerSlot: 'addAllToSelection', slot: 'selection' },
        { text: this.$t('endDevices:devEui'), slot: 'devEui', sort: 'devEui' },
        { text: this.$t('endDevices:name'), slot: 'name', sort: 'name' },
        { text: this.$t('endDevices:devAddr'), id: 'devAddr', sort: 'devAddr' },
        { text: this.$t('endDevices:classType'), id: 'classType', sort: 'classType', align: 'center' },
        { text: this.$t('endDevices:region'), formatter: endDevice => endDevice.rfRegion + (endDevice.country ? ` (${endDevice.country})` : '') },
        { text: this.$t('endDevices:version'), formatter: endDevice => `${endDevice.macVersion} ${endDevice.regParamsRevision}` },
        { text: this.$t('endDevices:status'), slot: 'status' },
        { text: this.$t('endDevices:profile'), slot: 'profile', sort: 'profile' },
        { text: this.$t('endDevices:adr'), slot: 'adrEnabled' },
        { text: this.$t('endDevices:lastDataUpMessage'), slot: 'lastDataUpDate' },
        { text: this.$t('endDevices:lastDataDownMessage'), slot: 'lastDataDownDate' }
      ],
      endDevices: {}
    }
  },

  computed: {
    ...mapGetters(['selectedCluster', 'selectedClusterId', 'endDevicesFilters']),

    regions () { return regions.regions },
    macVersions () { return regions.macVersions },
    regionalParameterRevisions () { return regions.regionalParameterRevisions },

    filterStatuses () {
      return sortBy(map(endDevicesStatuses, status => {
        return { id: status.value, name: upperFirst(this.$t('endDevices:statuses.' + status.value)) }
      }), ['name'])
    },

    maxPageSizePerFilterRequest () {
      return constants.maxPageSizePerFilterRequest
    },

    titleSmallNbFilters () {
      return this.nbFilters > 0 ? this.$t('endDevices:appliedFilter', { count: this.nbFilters }) : ''
    }
  },

  watch: {
    // When selectedCluster change, get list of endDevices for this cluster
    selectedCluster (newCluster, oldCluster) {
      // If cluster change, reset filters
      if (!isEqual(newCluster, oldCluster)) {
        this.filterName = ''
        this.filterClass = []
        this.filterRegions = []
        this.filterMacVersions = []
        this.filterRegionalParameterRevisions = []
        this.filterStatus = []
        this.filterProfile = ''
        this.filterDevEui = []
        this.filterAdr = ''
        this.filterDevAddr = ''
      }

      // Get page 1
      this.filter({ page: 1 })

      // Get EUI filter list
      this.getDevEuiList()
    }
  },

  created () {
    // Set saved filters
    this.filterName = this.endDevicesFilters.name || ''
    this.filterClass = this.endDevicesFilters.class || []
    this.filterRegions = this.endDevicesFilters.regions || []
    this.filterMacVersions = this.endDevicesFilters.macVersions || []
    this.filterRegionalParameterRevisions = this.endDevicesFilters.regionalParameterRevisions || []
    this.filterStatus = this.endDevicesFilters.status || []
    this.filterProfile = this.endDevicesFilters.profile || ''
    this.filterDevEui = this.endDevicesFilters.devEui || []
    this.filterAdr = this.endDevicesFilters.adr || ''
    this.filterDevAddr = this.endDevicesFilters.devAddr || ''

    // Only if cluster is empty (ie all clusters selected)
    if (isEmpty(this.selectedCluster) && this.selectedClusterId === -1) {
      this.filter()
      this.getDevEuiList()
    }
  },

  methods: {
    getDevEuiList: debounce(async function (searchQuery = '') {
      let search = []

      // Filter by selected cluster
      if (!isEmpty(this.selectedCluster)) search = this.$utils.addSearch(search, 'eq', this.selectedCluster.id, 'cluster.id')
      if (searchQuery) search = this.$utils.addSearch(search, 'like', '*' + searchQuery.toUpperCase() + '*', 'devEui')
      if (search.length > 0) search = JSON.stringify(search.length === 1 ? search[0] : this.$utils.formatSearch('and', search))

      let error, response
      [error, response] = await to(this.$api.getEndDevices(this.$store.getters.application, { pageSize: constants.maxPageSizePerFilterRequest, sort: '+devEui', fields: 'devEui', search }))
      if (error || !response) return

      // Add ... if all results are not displayed
      if (response.data.count < response.data.totalCount) {
        response.data.list.push({ devEui: '...', $isDisabled: true })
      }
      this.devEuiList = response.data.list
    }, 500),

    async filter (options = {}) {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      // Save filters
      this.$store.commit('setEndDevicesFilters', {
        name: this.filterName,
        class: this.filterClass,
        regions: this.filterRegions,
        macVersions: this.filterMacVersions,
        regionalParameterRevisions: this.filterRegionalParameterRevisions,
        status: this.filterStatus,
        profile: this.filterProfile,
        devEui: this.filterDevEui,
        adr: this.filterAdr,
        devAddr: this.filterDevAddr
      })

      // Add criteria
      let search = []
      if (this.filterName) search = this.$utils.addSearch(search, 'like', '*' + this.filterName + '*', 'name')
      if (this.filterClass.length > 0) search = this.$utils.addSearch(search, 'in', this.filterClass, 'classType')
      if (this.filterRegions.length > 0) search = this.$utils.addSearch(search, 'in', this.filterRegions, 'rfRegion')
      if (this.filterMacVersions.length > 0) search = this.$utils.addSearch(search, 'in', this.filterMacVersions, 'macVersion')
      if (this.filterRegionalParameterRevisions.length > 0) search = this.$utils.addSearch(search, 'in', this.filterRegionalParameterRevisions, 'regParamsRevision')

      if (this.filterDevEui.length > 0) {
        const devEuis = map(this.filterDevEui, endDevice => endDevice.devEui)
        search = this.$utils.addSearch(search, 'in', devEuis, 'devEui')
      }

      if (this.filterAdr) search = this.$utils.addSearch(search, 'eq', this.filterAdr, 'adrEnabled')
      if (this.filterDevAddr) search = this.$utils.addSearch(search, 'like', '*' + this.filterDevAddr + '*', 'devAddr')

      if (this.filterStatus.length > 0) {
        const status = map(this.filterStatus, status => status.id)
        search = this.$utils.addSearch(search, 'in', status, 'status')
      }

      if (this.filterProfile) search = this.$utils.addSearch(search, 'eq', this.filterProfile, 'profile')

      // Do not count fleet filter in filters count
      this.nbFilters = search.length

      // Filter by selected cluster
      if (!isEmpty(this.selectedCluster)) search = this.$utils.addSearch(search, 'eq', this.selectedCluster.id, 'cluster.id')

      // Format criteria
      if (search.length > 0) options.search = JSON.stringify(search.length === 1 ? search[0] : this.$utils.formatSearch('and', search))
      this.searchString = options.search

      // Get filtered data
      this.getEndDevices(options)
    },

    async getEndDevices (options) {
      let error, response
      [error, response] = await to(this.$api.getEndDevices(this.$store.getters.application, this.$utils.getParams({ sort: '+devEui' }, options, this.queryPageParams)))
      if (error || !response) return

      this.endDevices = response.data

      // We do it after getting data to prevent the column to appear before the data
      const columns = cloneDeep(this.columns)
      // Remove cluster colum
      remove(columns, c => c.slot === 'cluster')
      if (isEmpty(this.selectedCluster)) {
        // All clusters selected, add cluster colum
        columns.splice(2, 0, { text: this.$t('endDevices:cluster'), slot: 'cluster' })
      }
      this.columns = columns
    },

    addToSelection (endDevice) {
      this.$store.commit('addEndDeviceInSelection', endDevice)
    },

    addAllToSelection () {
      each(this.endDevices.list, (endDevice) => {
        this.addToSelection(endDevice)
      })
    },

    removeFromSelection (endDevice) {
      this.$store.commit('removeEndDeviceFromSelection', endDevice)
    }
  }
}
</script>
